import styled, { css } from 'styled-components';
import { ItemType } from '~/services/resolvers/types';
import FluffySlider from '@gotamedia/fluffy/Slider'
import { themeHelpers } from '@gotamedia/fluffy/theme'
import type { StyledMemoriaProps } from '../FamilyWidgetCards/types';

const CardWrapper = styled.div<StyledMemoriaProps>`
    display: flex;
    flex-direction: column;
    height: ${({ legacy }) => legacy ? 190 : 227}px;
    ${({ legacy }) => themeHelpers.isSmallDevice(css`${legacy ? "" : "height: 188px;"}`)};
    min-width: 170px;
    max-width: 200px;
    box-shadow: 0px 2px 4px rgba(46, 42, 37, 0.12);
    background: #fff;
    position: relative;
    align-items: center;
    padding: 8px;
    cursor: pointer;
        ${(props) => props.width === undefined ? undefined : css`
        width: ${props.width}px;
        margin-right: 10px;
    `}
    ${(props) => props.type !== ItemType.MemorialAd ? undefined : css`
        :after {
        position: absolute;
        bottom: 0;  
        height: 40%;
        width: 160px;
        content: "";
        background: linear-gradient(to top, rgba(255,255,255,1) 10%, rgba(255,255,255,0) 100% );
        pointer-events: none; /* so the text is still selectable */
        }
    `}
`

const Slider = styled(FluffySlider)<{width: number, legacy?: boolean}>`
    height: ${({ legacy }) => legacy ? 220 : 256}px;
    ${({ legacy }) => themeHelpers.isSmallDevice(css`${legacy ? "" : "height: 216px;"}`)};
    width: ${({ width }) => `${width}px`};
    margin: auto;
    ${themeHelpers.isSmallDevice(css`
        width: 100vw;
    `)};
`

const CardContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

const SliderStiles = styled(Slider.Slides)`
    width: auto;
`

const SliderContainer = styled.div<{ legacy?: boolean }>`
    display: flex;
    flex-direction: row;
    width: 100%;
    ${({ legacy }) => legacy ? "" : "height: 256px;"}
    ${({ legacy }) => themeHelpers.isSmallDevice(css`${legacy ? "" : "height: 216px;"}`)}
`

const Title = styled.h2`
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: "Sanomat Sans Text";
    margin-top: 5px;
    max-width: 90%;
    color: ${({ theme }) => theme.colors.grey[0]};
    `
const SubTitle = styled.h3`
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: "Sanomat Sans Text";
    margin-top: 5px;
    max-width: 90%;
    color: ${({ theme }) => theme.colors.grey[0]};
`

const Info = styled.span`
    font-weight: 400;
    font-size: 12px;
    font-family: "Sanomat Sans Text";
    line-height: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-top: 5px;
    max-width: 90%;
    color: ${({ theme }) => theme.colors.grey[2]};
    `

const ImageContainer = styled.div<{legacy?: boolean}>`
    display: flex;
    height: auto;
    width: 100%;
    margin-top: 0px;
    justify-content: center;
    min-height: ${({ legacy }) => legacy ? 90 : 80}px;
    overflow: hidden;
`

const CardImage = styled.img<StyledMemoriaProps>`
    max-width: 165px;
    max-height: ${({ legacy }) => legacy ? 90 : 80}px;
    height: 100%;
    ${(props) => props.type === ItemType.ChurchEventAd ? undefined : css`
      aspect-ratio: 3/2;
      width: 100%;
    `}
    ${(props) => props.type !== ItemType.MemorialAd ? undefined : css`
      object-fit: cover;
      margin: 0;
      padding:0;
      max-width: 160px;
      object-position: top;
    `}
`

export {
    Slider,
    Title,
    Info,
    CardWrapper,
    SliderStiles,
    CardContainer,
    ImageContainer,
    SliderContainer,
    CardImage,
    SubTitle,
};
